import React from 'react';
import './Logo.css';

function Logo({ selectedCountry }) {
  return (
    <div className="logo-container">
      {/* SVG Icon */}
      <svg
        className="logo-icon"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="logoThemeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#d32f2f" />         {/* red accent */}
            <stop offset="100%" stopColor="#0056b3" />       {/* blue accent */}
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="45" fill="none" stroke="url(#logoThemeGradient)" strokeWidth="5" />
        <text
          x="50"
          y="58"
          textAnchor="middle"
          fill="url(#logoThemeGradient)"
          fontSize="26"
          fontFamily="'Playfair Display', serif"
          fontWeight="bold"
        >
          OS
        </text>
      </svg>

      {/* Text Span */}
      <span className="logo-text">
        Origin<span className="select-text">Select</span>
      </span>
    </div>
  );
}

export default Logo;
